import { SITE_KEY } from 'constants/site';

const API_URL = `${process.env.API_URI}/api/email-subscriptions`;

const LIST_DATA_URI = `${API_URL}/email-lists/${SITE_KEY}`;
const SUBSCRIBE_URI = `${API_URL}/manage-subscriptions/${SITE_KEY}`;

export const REQUEST_HEADERS = {
  'Content-Type': 'application/json'
};

/**
 * simple helper function to handle HTTP errors, since unfetch doesn't reject
 * on HTTP errors.
 *
 * see https://github.com/developit/unfetch#caveats
 *
 * @export
 * @param {Object} response unfetch response object
 * @returns {Object}
 */
export function checkHttpStatus(response) {
  if (response.ok) {
    return response;
  }

  const error = new Error(response.statusText);
  error.response = response;
  return Promise.reject(error);
}

/**
 * fetches data for given listKey from email_subscriptions API. if no listKey is
 * passed, return undefined.
 *
 * @async
 * @export
 * @param {Number} listKey internal ID of list
 * @returns {Object} list data object
 */
// eslint-disable-next-line import/prefer-default-export
export async function fetchListData(listKey) {
  if (listKey === undefined) {
    return Promise.resolve(undefined);
  }

  const url = `${LIST_DATA_URI}/${listKey}`;

  const listData = await fetch(url, {
    method: 'GET',
    credentials: 'include'
  })
    .then(checkHttpStatus)
    .then(r => r.json());
  return listData;
}

/**
 * subscribes the provided email address to the provided listKey, referencing
 * the provided optInEvent, if any. thin wrapper around our email_subscriptions
 * subscribe API endpoint.
 *
 * @async
 * @export
 * @param {Object} opts
 * @param {String} opts.email email address to subscribe
 * @param {Number} opts.listKey target list id for subscription
 * @param {String} [opts.optInEvent=''] optional opt-in event
 * @param {String} [opts.sailthruContent=''] optional sailthru content cookie
 * @returns {Object} response from email_subs API
 */
export async function subscribeUserToList({
  email,
  listKey,
  optInEvent = '',
  sailthruContent = ''
}) {
  const body = JSON.stringify({
    email,
    email_list_keys: [listKey],
    opt_event: optInEvent,
    sailthru_content: sailthruContent
  });

  const resp = await fetch(`${SUBSCRIBE_URI}`, {
    method: 'POST',
    headers: REQUEST_HEADERS,
    credentials: 'include',
    body
  }).then(checkHttpStatus);
  return resp;
}
